<div class="container-fluid">
  <div class="row min-hieght-2500px display_block lms-cstm-content">
    <div class="col-md-12 col-lg-12 col-sm-12 col-12 side-bar-cstm">
  <h3>Edit Syllabus</h3>
    <div class="list-group" id="items"> 
      <!-- <div class="modal-cross-wrap">
      <i class="ft-x cursor-pointer" (click)="close()"></i>
    </div> -->
    <ul>
  <li class="cursor" *ngFor="let section of sections; let sectionIndex = index">
    <div class="list-group-item section-list">
      <div class="sidee-nav-section">
        <div class="list-title">
          <input type="checkbox" [name]="'sectionIndex'+sectionIndex" class="checkbox-style" [(ngModel)]="section.checked" (change)="sectionSelection($event,sectionIndex)" [ngModelOptions]="{standalone: true}">
          {{ section?.name }}
          <i *ngIf="section?.chapters?.length > 0" class="ft-chevron-down" (click)="activeBreadcrumb(section?.name, section?._id)" data-toggle="collapse" [attr.data-target]="'#sectionCollapse' + sectionIndex" [ngClass]="{'active-section': activeSectionId == section?._id}"></i>
        </div>
      </div>
      <ul>
        <li class="cursor" *ngFor="let chapter of section?.chapters; let chapterIndex = index">
          <div class="list-group-item chapter-list" [ngClass]="{'active-chapter': activeChapterId == chapter?._id}">
            <div (click)="activeBreadcrumb(section?.name, section?._id, chapter?.name, chapter?._id)" data-toggle="collapse" class="inner-chapter" [attr.data-target]="'#chapterCollapse' + sectionIndex + '-' + chapterIndex">
              <div class="list-title">
                <input type="checkbox" [name]="'chapterIndex'+chapterIndex" class="checkbox-style" [(ngModel)]="chapter.checked" [value]="chapter.checked" (change)="chapterSelection($event,sectionIndex,chapterIndex)" [ngModelOptions]="{standalone: true}">
                {{ chapter?.name }}
                <i *ngIf="chapter?.topics?.length > 0" class="ft-chevron-down"></i>
              </div>
            </div>
            <ul>
              <li class="cursor" *ngFor="let topic of chapter.topics; let topicIndex = index">
                <div class="list-group-item topic-list" [ngClass]="{'active-topic': activeTopicId == topic?._id}">
                  <div class="list-title">
                    <input type="checkbox" [name]="'topicIndex'+topicIndex" class="checkbox-style" [(ngModel)]="topic.checked" (change)="topicSelection($event,sectionIndex,chapterIndex,topicIndex)" [ngModelOptions]="{standalone: true}">
                    {{ topic.name }}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </li>
</ul>

    </div>
  
    </div>
   
    <div class="col-12 d-flex flex-sm-row flex-column justify-content-center mt-3 mb-3 mt-sm-2">
      <button type="submit" class="btn btn-primary mb-2 mb-sm-0 mr-sm-2" (click)="save()">
          Submit
      </button>
      <button type="reset" class="btn btn-secondary" (click)="close()">
          Cancel
      </button>
  </div>
  </div>
  </div>
